import { useEffect } from "react";
import { useCustomization } from "../../contexts/CustomizationContext";
import "./ChangeBanner.css";

export default function ChangeBanner() {
    const { isTryingOn, saveChanges, resetChanges } = useCustomization();

    useEffect(() => {});
    return (
        <div className="change-banner">
            {isTryingOn && (
                <>
                    <span>Unable to save changes while trying items on.</span>
                </>
            )}
            {!isTryingOn && (
                <>
                    <span>You have unsaved changes.</span>
                    <button onClick={saveChanges}>Save</button>
                </>
            )}
            <button onClick={resetChanges}>Reset</button>
        </div>
    );
}
